import { defineComponent as x, inject as g, useCssModule as V, createElementBlock as c, openBlock as s, normalizeClass as v, unref as e, Fragment as R, renderList as I, createElementVNode as u, toDisplayString as $, provide as S, computed as m, ref as C, useTemplateRef as j, onMounted as D, onUnmounted as q, watchEffect as A, createBlock as M, mergeProps as L, withCtx as N, renderSlot as W, resolveDynamicComponent as P } from "vue";
import U from "lodash-es/uniqueId";
import { R as k } from "./RadioGroup.keys-CqfiKkNz.js";
import { _ as B } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { _ as F } from "./Field.vue_vue_type_script_setup_true_lang-DI6z3AE9.js";
const J = ["id", "name", "value", "checked", "disabled"], H = ["for"], K = /* @__PURE__ */ x({
  __name: "VariantButton",
  setup(p) {
    const i = g(k.key);
    if (!i)
      throw new Error("VariantButton must be used with a RadioGroup instance.");
    const { name: o, disabled: a, fullWidth: b, modelValue: d, options: f, update: l } = i, _ = V();
    return (h, n) => (s(), c("div", {
      class: v(["tw-flex", e(_).root])
    }, [
      (s(!0), c(R, null, I(e(f), (t) => (s(), c("div", {
        key: `${e(o)}-${t.id}`,
        class: v([{ "tw-w-full": e(b) }])
      }, [
        u("input", {
          id: `${e(o)}-${t.id}`,
          class: "tw-sr-only",
          type: "radio",
          name: e(o),
          value: t.value,
          checked: e(d) === t.value,
          disabled: e(a) || t.disabled,
          onInput: n[0] || (n[0] = //@ts-ignore
          (...w) => e(l) && e(l)(...w))
        }, null, 40, J),
        u("label", {
          for: `${e(o)}-${t.id}`
        }, $(t.text), 9, H)
      ], 2))), 128))
    ], 2));
  }
}), Q = "_root_1bamn_2", X = {
  root: Q
}, Y = {
  $style: X
}, Z = /* @__PURE__ */ B(K, [["__cssModules", Y]]), ee = ["id", "name", "value", "checked", "disabled"], te = ["for"], ae = /* @__PURE__ */ x({
  __name: "VariantChip",
  setup(p) {
    const i = g(k.key);
    if (!i)
      throw new Error("VariantChip must be used with a RadioGroup instance.");
    const { name: o, disabled: a, fullWidth: b, modelValue: d, options: f, update: l } = i, _ = V();
    return (h, n) => (s(), c("div", {
      class: v(["tw-my-1.5 tw-flex tw-flex-wrap", e(_).root])
    }, [
      (s(!0), c(R, null, I(e(f), (t) => (s(), c("div", {
        key: `${e(o)}-${t.id}`,
        class: v([{ "tw-w-full": e(b) }])
      }, [
        u("input", {
          id: `${e(o)}-${t.id}`,
          class: "tw-sr-only",
          type: "radio",
          name: e(o),
          value: t.value,
          checked: e(d) === t.value,
          disabled: e(a) || t.disabled,
          onInput: n[0] || (n[0] = //@ts-ignore
          (...w) => e(l) && e(l)(...w))
        }, null, 40, ee),
        u("label", {
          for: `${e(o)}-${t.id}`
        }, $(t.text), 9, te)
      ], 2))), 128))
    ], 2));
  }
}), oe = "_root_kagur_2", re = {
  root: oe
}, le = {
  $style: re
}, se = /* @__PURE__ */ B(ae, [["__cssModules", le]]), ne = ["id", "name", "value", "checked", "disabled"], ie = ["for"], de = /* @__PURE__ */ x({
  __name: "VariantRadio",
  setup(p) {
    const i = g(k.key);
    if (!i)
      throw new Error("VariantRadio must be used with a RadioGroup instance.");
    const { name: o, disabled: a, fullWidth: b, modelValue: d, options: f, update: l } = i, _ = V();
    return (h, n) => (s(), c("div", {
      class: v(["tw-flex tw-flex-wrap", e(_).root])
    }, [
      (s(!0), c(R, null, I(e(f), (t) => (s(), c("div", {
        key: `${e(o)}-${t.id}`,
        class: v([{ "tw-w-full": e(b) }])
      }, [
        u("input", {
          id: `${e(o)}-${t.id}`,
          type: "radio",
          name: e(o),
          value: t.value,
          checked: e(d) === t.value,
          disabled: e(a) || t.disabled,
          onInput: n[0] || (n[0] = //@ts-ignore
          (...w) => e(l) && e(l)(...w))
        }, null, 40, ne),
        u("label", {
          for: `${e(o)}-${t.id}`
        }, $(t.text), 9, ie)
      ], 2))), 128))
    ], 2));
  }
}), ue = "_root_11y1n_2", ce = {
  root: ue
}, _e = {
  $style: ce
}, pe = /* @__PURE__ */ B(de, [["__cssModules", _e]]), ve = ["for"], fe = ["id", "name", "value", "checked", "disabled"], me = { class: "tw-m-0 tw-text-ice-900" }, be = { class: "tw-m-0 tw-text-ice-700" }, we = /* @__PURE__ */ x({
  __name: "VariantTile",
  setup(p) {
    const i = g(k.key);
    if (!i)
      throw new Error("VariantTile must be used with a RadioGroup instance.");
    const { name: o, disabled: a, fullWidth: b, modelValue: d, options: f, update: l } = i, _ = V();
    return (h, n) => (s(), c("div", {
      class: v(["tw-flex tw-flex-wrap", e(_).root])
    }, [
      (s(!0), c(R, null, I(e(f), (t) => (s(), c("label", {
        key: `${e(o)}-${t.id}`,
        class: v([e(_)["tile-container"], { "tw-w-full": e(b) }]),
        for: `${e(o)}-${t.id}`
      }, [
        u("div", {
          class: v(["tw-flex tw-border", [
            e(_)["tile-header"],
            {
              "tw-border-blue-500 tw-bg-blue-100 tw-text-ice-900": e(d) === t.value,
              "tw-border-ice-500 tw-bg-ice-100 tw-text-ice-700": e(d) !== t.value
            }
          ]])
        }, [
          u("input", {
            id: `${e(o)}-${t.id}`,
            class: "tw-sr-only",
            type: "radio",
            name: e(o),
            value: t.value,
            checked: e(d) === t.value,
            disabled: e(a) || t.disabled,
            onInput: n[0] || (n[0] = //@ts-ignore
            (...w) => e(l) && e(l)(...w))
          }, null, 40, fe),
          u("div", null, [
            u("span", null, $(t.text), 1)
          ])
        ], 2),
        u("div", {
          class: v(["tw-border-x tw-border-b", [
            e(_)["tile-body"],
            {
              "tw-border-ice-500": e(d) !== t.value,
              "tw-border-blue-500": e(d) === t.value
            }
          ]])
        }, [
          u("p", me, $(t.subTitle), 1),
          u("p", be, $(t.subText), 1)
        ], 2)
      ], 10, ve))), 128))
    ], 2));
  }
}), he = "_root_1sppn_2", $e = {
  root: he,
  "tile-container": "_tile-container_1sppn_23",
  "tile-header": "_tile-header_1sppn_30",
  "tile-body": "_tile-body_1sppn_31"
}, ye = {
  $style: $e
}, xe = /* @__PURE__ */ B(we, [["__cssModules", ye]]);
var y = /* @__PURE__ */ ((p) => (p.Radio = "radio", p.Button = "button", p.Chip = "chip", p.Tile = "tile", p))(y || {});
const ke = /* @__PURE__ */ x({
  __name: "RadioGroup",
  props: {
    name: { default: void 0 },
    options: { default: void 0 },
    modelValue: { default: void 0 },
    variant: { default: "radio" },
    fullWidth: { type: Boolean, default: !1 },
    orientation: { default: "horizontal" },
    addBottomSpace: { type: Boolean },
    errorText: {},
    hintText: {},
    id: {},
    errorId: {},
    isReadOnly: { type: Boolean },
    isRequired: { type: Boolean },
    label: {},
    showOptionalInLabel: { type: Boolean },
    isLabelSrOnly: { type: Boolean },
    fieldset: { type: Boolean },
    isDisabled: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(p, { emit: i }) {
    const o = {
      [y.Button]: Z,
      [y.Chip]: se,
      [y.Radio]: pe,
      [y.Tile]: xe
    }, a = p, b = i;
    function d(r) {
      b("update:modelValue", r.target.value);
    }
    const f = U("radio-group-field-error-");
    S(k.key, {
      name: m(() => a.name),
      disabled: m(() => a.isDisabled || a.disabled),
      fullWidth: m(() => a.fullWidth),
      modelValue: m(() => a.modelValue),
      options: m(() => a.options),
      variant: m(() => a.variant),
      orientation: m(() => l.value),
      update: d
    });
    const l = C(a.orientation), _ = m(() => ({
      "tw-flex-wrap": a.variant !== "button",
      "tw-gap-x-1.5 tw-gap-y-3": a.variant === "chip" && l.value === "horizontal",
      "tw-gap-6": a.variant === "radio" || a.variant === "tile" || a.variant === "chip" && l.value === "vertical",
      "tw-flex-col": l.value === "vertical"
    })), h = C(null), n = j("radioGroup"), t = m(() => {
      var r;
      return (r = n.value) == null ? void 0 : r.$el.parentElement;
    }), w = m(() => {
      var r;
      return a.variant !== "button" ? [] : Array.from((r = n.value) == null ? void 0 : r.$el.querySelectorAll("[data-variant-button]")) || [];
    });
    function E() {
      return w.value.reduce((r, T) => {
        const z = T.getBoundingClientRect().width;
        return r + z;
      }, 0);
    }
    const G = C(0), O = (r) => {
      l.value = G.value > r.contentBoxSize[0].inlineSize ? "vertical" : a.orientation;
    };
    return D(() => {
      a.variant === "button" && !a.fullWidth && (G.value = E(), h.value = new ResizeObserver((r) => O(r[0])), h.value.observe(t.value));
    }), q(() => {
      var r;
      a.variant === "button" && h.value && ((r = h.value) == null || r.disconnect());
    }), A(() => {
      l.value = a.orientation;
    }), (r, T) => (s(), M(F, L(a, {
      ref: "radioGroup",
      class: "stash-radio-group",
      "data-test": "stash-radio-group",
      "aria-errormessage": e(f),
      "error-id": e(f),
      "aria-invalid": !!a.errorText,
      role: "radiogroup",
      fieldset: ""
    }), {
      default: N(() => [
        a.options ? W(r.$slots, "default", { key: 0 }, () => [
          (s(), M(P(o[a.variant])))
        ], !0) : (s(), c("div", {
          key: 1,
          class: v(["tw-flex", _.value]),
          "data-test": "stash-radio-group|default-slot"
        }, [
          W(r.$slots, "default", {}, void 0, !0)
        ], 2))
      ]),
      _: 3
    }, 16, ["aria-errormessage", "error-id", "aria-invalid"]));
  }
}), Ce = /* @__PURE__ */ B(ke, [["__scopeId", "data-v-fd3f362b"]]);
export {
  k as RADIO_GROUP_INJECTION,
  y as RadioGroupVariant,
  Ce as default
};
//# sourceMappingURL=RadioGroup.js.map
